import React from 'react';
import FacebookIcon from '../../images/icons/facebook-icon.svg';
import LinkedinIcon from '../../images/icons/linkedin-icon.svg';
import TwitterIcon from '../../images/icons/twitter-icon.svg';

function SocialShare(props) {
  return (
    <>
      <span data-href="https://developers.facebook.com/docs/plugins/" className="facebook">
        <a href={`https://www.facebook.com/sharer/sharer.php?u=https://www.kleinerperkins.com${props.prefix}${props.slug.current}&title=${props.title}`} target="_blank" rel="noopener">
          <FacebookIcon />
        </a>
      </span>
      <a href={`http://twitter.com/intent/tweet?text=${props.title}&url=https://www.kleinerperkins.com${props.prefix}${props.slug.current}&via=kleinerperkins`} target="_blank" rel="noopener">
        <TwitterIcon />
      </a>
      <a href={`http://www.linkedin.com/shareArticle?mini=true&url=https://www.kleinerperkins.com${props.prefix}${props.slug.current}&title=${props.title}&summary=${props.title}&source=kleiner-perkins`} className="popup" target="_blank" rel="noopener">
        <LinkedinIcon />
      </a>
    </>
  );
}

export default SocialShare;
